import React from 'react';
import { CheckCircle2Icon, SparklesIcon } from 'lucide-react';
export function Opportunity() {
  const noLongerNeed = ['Ya no necesitas saber editar', 'Ya no necesitas grabarte', 'Ya no necesitas equipo caro'];
  const workflow = [{
    step: 'Elige un tema viral',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/umVfnnx8FKEDFRttUM7ned/Generated_Image_November_05%2C_2025_-_9_31PM.png',
    module: 'Módulo 1',
    value: 47
  }, {
    step: 'Genera un guión poderoso con IA',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tbRU6G6SGibBuV1mHAPWNb/Generated_Image_November_05%2C_2025_-_9_31PM_%282%29.png',
    module: 'Módulo 2',
    value: 47
  }, {
    step: 'Agrega voz con emoción humana',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7PH3eFRQMoCGiDyXMtEEFt/Generated_Image_November_05%2C_2025_-_9_32PM.png',
    module: 'Módulo 3',
    value: 47
  }, {
    step: 'Diseña escenas visuales con IA',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1dVRxj6XSxdJRE5XWa1pfi/Generated_Image_November_05%2C_2025_-_9_33PM.png',
    module: 'Módulo 4',
    value: 47
  }, {
    step: 'Anima con herramientas de video IA',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9emRCsxkKhvQc4saCXNJ1Y/Generated_Image_November_05%2C_2025_-_9_34PM.png',
    module: 'Módulos 5 y 6',
    value: 47
  }];
  const totalValue = workflow.reduce((sum, item) => sum + item.value, 0);
  const sellingPrice = 6.97;
  const savings = (totalValue - sellingPrice).toFixed(2);
  return <section className="w-full px-4 py-16 md:py-20" data-id="element-194">
      <div className="max-w-4xl mx-auto" data-id="element-195">
        <div className="text-center mb-10" data-id="element-196">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-500/20 border border-green-500/30 rounded-full mb-6" data-id="element-197">
            <SparklesIcon className="w-4 h-4 text-green-300" data-id="element-198" />
            <span className="text-green-200 text-sm font-medium" data-id="element-199">
              Buenas noticias
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-200">
            Estamos viviendo una nueva era en la economía de creadores
          </h2>
          <p className="text-base md:text-xl text-gray-300 mb-8" data-id="element-201">
            Herramientas como ChatGPT, Midjourney, Pika y ElevenLabs lo han
            cambiado todo:
          </p>
        </div>
        <div className="bg-gradient-to-br from-green-500/10 to-emerald-500/10 border border-green-500/30 rounded-2xl p-6 md:p-8 mb-10" data-id="element-202">
          <div className="space-y-4" data-id="element-203">
            {noLongerNeed.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-204">
                <CheckCircle2Icon className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-205" />
                <p className="text-base md:text-xl text-gray-200 font-medium" data-id="element-206">
                  {item}
                </p>
              </div>)}
          </div>
          <p className="text-base md:text-xl text-gray-300 mt-8 text-center" data-id="element-207">
            Solo necesitas un flujo simple que conecte estas herramientas.
          </p>
        </div>
        <div className="bg-slate-800/50 border border-purple-500/30 rounded-2xl p-6 md:p-8" data-id="element-208">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-6 text-center leading-tight" data-id="element-209">
            Eso es exactamente lo que hace{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400" data-id="element-210">
              Viral Video Machine IA
            </span>
            .
          </h3>
          <p className="text-base md:text-lg text-gray-300 mb-8 text-center" data-id="element-211">
            Así funciona el sistema:
          </p>
          <div className="space-y-4 mb-8" data-id="element-212">
            {workflow.map((item, index) => <div key={index} className="bg-slate-700/30 rounded-xl overflow-hidden border border-slate-600/30 hover:border-purple-500/50 transition-colors" data-id="element-213">
                <div className="flex flex-col sm:flex-row" data-id="element-214">
                  <div className="w-full sm:w-32 h-32 sm:h-auto flex-shrink-0" data-id="element-215">
                    <img src={item.image} alt={item.module} className="w-full h-full object-cover" data-id="element-216" />
                  </div>
                  <div className="flex-1 p-4 flex items-center" data-id="element-217">
                    <div className="flex items-start gap-3 w-full" data-id="element-218">
                      <span className="text-purple-400 font-bold text-lg flex-shrink-0" data-id="element-219">
                        {index + 1}.
                      </span>
                      <div className="flex-1" data-id="element-220">
                        <div className="flex items-start justify-between gap-2 mb-1" data-id="element-221">
                          <p className="text-sm md:text-base text-gray-200 font-medium" data-id="element-222">
                            {item.step}
                          </p>
                          <span className="text-sm font-bold text-purple-300 whitespace-nowrap" data-id="element-223">
                            ${item.value}
                          </span>
                        </div>
                        <p className="text-xs text-purple-300" data-id="element-224">{item.module}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="bg-gradient-to-br from-purple-600/20 to-pink-600/20 border border-purple-500/50 rounded-xl p-6 mb-6" data-id="element-225">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-4" data-id="element-226">
              <span className="text-base md:text-lg text-gray-300" data-id="element-227">
                Valor Total del Sistema:
              </span>
              <span className="text-2xl md:text-3xl font-bold text-white" data-id="element-228">
                ${totalValue}
              </span>
            </div>
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-4" data-id="element-229">
              <span className="text-base md:text-lg text-gray-300" data-id="element-230">
                Precio de Hoy:
              </span>
              <span className="text-2xl md:text-3xl font-bold text-green-400" data-id="element-231">
                ${sellingPrice}
              </span>
            </div>
            <div className="pt-4 border-t border-purple-500/30" data-id="element-232">
              <div className="flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-233">
                <span className="text-base md:text-lg font-bold text-purple-300" data-id="element-234">
                  Ahorras:
                </span>
                <span className="text-2xl md:text-3xl font-bold text-yellow-400" data-id="element-235">
                  ${savings}
                </span>
              </div>
            </div>
          </div>
          <div className="text-center" data-id="element-236">
            <p className="text-xl md:text-2xl font-bold text-white leading-tight" data-id="element-237">
              Todo en menos de{' '}
              <span className="text-purple-400" data-id="element-238">60 minutos</span> — desde cero
              hasta un video listo para volverse viral.
            </p>
          </div>
        </div>
      </div>
    </section>;
}